import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APPCONFIG } from '../_store/appConfig';

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoaderService implements TranslateLoader {
  constructor(private httpClient: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const url = `${APPCONFIG.urls.langAssetsUrl}${lang}.json`;
    return this.httpClient.get(url).pipe(catchError((_) => this.httpClient.get(`/assets/i18n/${lang}.json`)));
  }
}
